import {
	DadosGraficoVariaveis,
	DadosSerieVariavelMeteorologica,
	SerieVariavelMeteorologica,
} from './serie-variavel-meteorologica';
import mensagens from './mensagens';
import { getOptions } from 'highcharts';

export interface DadosPressao extends DadosGraficoVariaveis {
	pressao: number[];
}

export class SeriePressao extends SerieVariavelMeteorologica {
	constructor(readonly nomeDaSerie?: string) {
		super();
	}

	obterDadosSerie(
		dados: DadosPressao,
		indexEixo: number
	): DadosSerieVariavelMeteorologica {
		return {
			serie: [
				{
					yAxis: indexEixo,
					name: this.nomeDaSerie
						? this.nomeDaSerie
						: mensagens['variavel.pressao'],
					type: 'spline',
					data: super.prepararSerie(dados.datas, dados.pressao),
					color: getOptions().colors?.at(1),
					tooltip: {
						valueDecimals: 2,
						valueSuffix: ` ${mensagens['variavel.pressao.unidade']}`,
					},
				},
			],
			eixo: {
				title: {
					text: this.nomeDaSerie
						? this.adicionarUnidade(this.nomeDaSerie)
						: mensagens['variavel.pressao.titulo-meteograma'],
				},
				offset: 0,
				min: 800,
				softMax: 1000,
				lineWidth: 2,
				opposite: false,
				labels: { align: 'left', x: 3 },
			},
		};
	}

	private adicionarUnidade(nomeDaSerie: string): string {
		return nomeDaSerie + ` ( ${mensagens['variavel.pressao.unidade']} )`;
	}
}
